const BREAKPOINTS = {
  tablet: "768px"
};

export { BREAKPOINTS };
//# sourceMappingURL=constants.es.js.map
